import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { fetchNewsDetail } from '../news/api';

const fmt = (d) => (d || '').slice(0, 10);
const cardImage = (src = '') => src
  .replace('news-1782815639549-91275285-enhanced.jpg', 'news-1782815639549-91275285-card.jpg')
  .replace('news-1782815630502-7793fb63-enhanced.jpg', 'news-1782815630502-7793fb63-card.jpg');

export default function NewsDetail() {
  const { slug } = useParams();
  const [data, setData] = useState(undefined);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    setData(undefined); setError('');
    fetchNewsDetail(slug).then((d) => { if (alive) setData(d); }).catch((e) => { if (alive) { setError(e.message); setData(null); } });
    return () => { alive = false; };
  }, [slug]);

  if (data === undefined) {
    return <div className="page-top container-x py-24 text-center" style={{ color: 'var(--muted)' }}>加载中…</div>;
  }
  if (data === null) {
    return (
      <div className="page-top container-x pb-24 text-center">
        <h1 className="text-3xl md:text-5xl font-semibold tracking-tight" style={{ color: 'var(--ink)' }}>没有找到这篇新闻</h1>
        <p className="mt-4" style={{ color: 'var(--muted)' }}>{error || '它可能已被删除或尚未发布。'}</p>
        <Link to="/news" className="btn btn-blue mt-8">返回新闻中心</Link>
      </div>
    );
  }

  const { item, prev, next, related } = data;
  const safeHtml = DOMPurify.sanitize(item.content || '');

  return (
    <article>
      {/* 头部 */}
      <header className="page-top pb-10 text-center">
        <div className="container-x mx-auto max-w-3xl">
          <div className="text-[14px] reveal" style={{ color: 'var(--muted)' }}>
            {item.category} · {fmt(item.publishDate)}{item.author ? ` · ${item.author}` : ''}
          </div>
          <h1 className="mt-4 text-3xl md:text-5xl font-semibold leading-tight tracking-tight reveal" style={{ color: 'var(--ink)', transitionDelay: '0.05s' }}>
            {item.title}
          </h1>
        </div>
      </header>

      {/* 正文 */}
      <div className="container-x mx-auto max-w-3xl pb-20">
        {item.coverImage && (
          <img src={item.coverImage} alt={item.title} className="mb-12 w-full" style={{ borderRadius: '18px' }} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        )}
        {item.summary && (
          <p className="mb-10 text-xl md:text-2xl font-light leading-relaxed" style={{ color: '#3a3a3c' }}>{item.summary}</p>
        )}
        <div className="article-body" dangerouslySetInnerHTML={{ __html: safeHtml }} />

        {/* 上/下一篇 */}
        <div className="mt-16 grid gap-6 sm:grid-cols-2" style={{ borderTop: '1px solid var(--line)', paddingTop: '2rem' }}>
          {prev ? (
            <Link to={`/news/${prev.slug}`} className="group">
              <div className="text-[13px]" style={{ color: 'var(--muted)' }}>上一篇</div>
              <div className="mt-1 font-medium transition-opacity group-hover:opacity-60" style={{ color: 'var(--ink)' }}>{prev.title}</div>
            </Link>
          ) : <div />}
          {next ? (
            <Link to={`/news/${next.slug}`} className="group sm:text-right">
              <div className="text-[13px]" style={{ color: 'var(--muted)' }}>下一篇</div>
              <div className="mt-1 font-medium transition-opacity group-hover:opacity-60" style={{ color: 'var(--ink)' }}>{next.title}</div>
            </Link>
          ) : <div />}
        </div>

        <div className="mt-10 text-center">
          <Link to="/news" className="link-accent">‹ 返回新闻中心</Link>
        </div>
      </div>

      {/* 相关推荐 */}
      {related && related.length > 0 && (
        <section className="section-alt py-20 md:py-28">
          <div className="container-x">
            <h2 className="text-2xl md:text-3xl font-semibold tracking-tight" style={{ color: 'var(--ink)' }}>相关推荐</h2>
            <div className="mt-10 grid gap-x-8 gap-y-12 md:grid-cols-3">
              {related.map((n) => (
                <Link key={n.id} to={`/news/${n.slug}`} className="group block">
                  <div className="overflow-hidden aspect-[16/9]" style={{ borderRadius: '16px', background: 'var(--bg)' }}>
                    {n.coverImage && <img src={cardImage(n.coverImage)} alt={n.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.01]" onError={(e) => { e.currentTarget.style.display = 'none'; }} />}
                  </div>
                  <div className="mt-3 text-[13px]" style={{ color: 'var(--muted)' }}>{fmt(n.publishDate)}</div>
                  <h3 className="mt-1 text-[17px] font-semibold transition-opacity group-hover:opacity-70" style={{ color: 'var(--ink)' }}>{n.title}</h3>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </article>
  );
}